import * as React from "react";

interface Props {
  style?: React.CSSProperties;
  className?: string;
}
export const GroupIcon: React.FC<Props> = ({ style = {}, className = "" }) => {
  // style="enable-background:new 0 0 512 512;"
  return (
    <svg
      style={style}
      className={className}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <circle cx="255.996" cy="60.812" r="45.043" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M329.101,77.346c-7.571,33.44-37.404,58.538-73.1,58.538s-65.529-25.098-73.1-58.538
			c-26.851,5.983-47.015,29.906-47.015,58.538v60.058c0,16.554,13.475,30.029,30.029,30.029s30.029-13.475,30.029-30.029v-30.029
			h120.115v30.029c0,16.554,13.475,30.029,30.029,30.029c16.554,0,30.029-13.475,30.029-30.029v-60.058
			C376.116,107.252,355.951,83.329,329.101,77.346z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M488.717,382.722c-21.545-12.439-49.092-5.059-61.531,16.486c-12.438,21.543-5.057,49.092,16.488,61.529
			c21.543,12.439,50.093,5.057,62.53-16.486C518.643,422.707,510.26,395.16,488.717,382.722z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M461.237,280.171l-52.01-30.029c-14.337-8.277-32.743-3.345-41.02,10.992c-8.277,14.337-3.345,32.743,10.992,41.02
			l26.006,15.014l-60.058,104.023l-26.006-15.014c-14.337-8.277-32.743-3.345-41.02,10.992c-8.277,14.337-3.345,32.743,10.992,41.02
			l52.01,30.029c24.798,14.316,55.598,8.814,74.203-11.448c-25.174-23.276-31.994-61.661-14.146-92.576
			c17.848-30.915,54.5-44.2,87.246-34.038C496.671,323.913,486.035,294.487,461.237,280.171z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M84.815,399.209c-12.439-21.545-39.986-28.926-61.531-16.486C1.741,395.161-6.643,422.708,5.797,444.253
			c12.437,21.543,40.987,28.925,62.53,16.486C89.872,448.3,97.253,420.752,84.815,399.209z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M233.88,417.169c-8.277-14.337-26.684-19.268-41.02-10.992l-26.006,15.014l-60.058-104.023l26.006-15.014
			c14.337-8.277,19.268-26.684,10.992-41.02c-8.277-14.337-26.684-19.268-41.02-10.992l-52.01,30.029
			c-24.798,14.316-35.434,43.742-27.188,69.986c32.745-10.163,69.398,3.123,87.246,34.038s11.028,69.299-14.146,92.576
			c18.605,20.261,49.405,25.764,74.203,11.448l52.01-30.03C237.225,449.912,242.157,431.505,233.88,417.169z"
          />
        </g>
      </g>
    </svg>
  );
};
